export default __webpack_public_path__ + "static/media/pitch-video.f504d565.png";